import { Link, useLocation } from "react-router-dom";

const TABS = [
  { path: "/admin/dashboard", label: "Stats" },
  { path: "/admin/costos", label: "Costos" },
  { path: "/admin/prompts-ia", label: "Prompts IA" },
  { path: "/admin/categorias", label: "Categorías" },
];

export const AdminNav = () => {
  const location = useLocation();
  return (
    <div className="flex flex-wrap gap-2 mb-8" data-testid="admin-nav">
      {TABS.map((t) => {
        const active = location.pathname === t.path;
        return (
          <Link
            key={t.path}
            to={t.path}
            data-testid={`nav-${t.path.split("/").pop()}`}
            className={`press border-4 border-[#1a1a1a] rounded-full px-4 py-1.5 font-mono text-xs uppercase font-bold shadow-hard-sm ${
              active ? "bg-[#1a1a1a] text-white" : "bg-white"
            }`}
          >
            {t.label}
          </Link>
        );
      })}
    </div>
  );
};

export default AdminNav;
